import { render } from "./Picker.vue?vue&type=template&id=e8749a2a&ts=true"
import script from "./Picker.vue?vue&type=script&lang=ts"
export * from "./Picker.vue?vue&type=script&lang=ts"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__